import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class AccountType {

  public static GIVE_UP_CODE: string = "Gup";

  @JsonProperty()
  id: string | undefined;

  @JsonProperty()
  code: string | undefined;

  @JsonProperty()
  description: string | undefined;

  @JsonProperty()
  exchangeCode: string | undefined;

  @JsonProperty()
  clearingHouse: string | undefined;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}
